// FOLIO — warm paper letter. A single cream card set in serif italics with a
// small "Q & A" kicker and a fleuron ornament. Every answer is visible (no
// toggles); items get a staggered entrance reveal. The paper wrapper flips to
// a warm dark tone via cssDark.
function itemHtml(ctx, it) {
    return `<div class="fq-item"${ctx.reveal(it.idx)}>
  <h3 class="fq-q">${it.q}</h3>
  <div class="fq-a">${it.aHtml}</div>
</div>`;
}
const folio = {
    id: 'folio',
    name: 'Folio',
    tag: 'Paper letter',
    styleTag: 'Warm serif',
    description: 'A warm paper card set in serif italics, like a letter from the founder. For brands that write like humans \u2014 studios, caf\u00e9s, small teams.',
    layout: 'list',
    defaultAccent: '#d97706',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <p class="fq-kicker">${ctx.t('qa')}</p>
  <h2 class="fq-title">${ctx.title}</h2>
  <p class="fq-orn" aria-hidden="true">&#10087;</p>
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:660px;margin:0 auto;padding:46px 44px 50px;background:#faf6ec;border:1px solid #e8dfc9;border-radius:min(${ctx.v.radius},4px)}
.FQM .fq-kicker{margin:0 0 6px;text-align:center;font-size:12px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:${ctx.v.accent}}
.FQM .fq-title{margin:0 0 8px;text-align:center;font-family:${ctx.v.head};font-size:36px;font-weight:550;line-height:1.1;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-orn{margin:0 0 30px;text-align:center;font-family:${ctx.v.serif};font-size:18px;color:${ctx.v.sub}}
.FQM .fq-list{display:flex;flex-direction:column;gap:30px}
.FQM .fq-q{margin:0 0 7px;font-family:${ctx.v.head};font-size:20px;font-weight:550;font-style:italic;line-height:1.35;color:${ctx.v.ink}}
.FQM .fq-a{font-size:15px;line-height:1.7;color:${ctx.v.sub}}
`;
        const cssDark = `
.FQM .fq-wrap{background:#211d14;border-color:rgba(255,255,255,0.14)}
`;
        return { html, css, cssDark };
    },
};
export default folio;
